/* eslint-disable jsx-a11y/label-has-associated-control */
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Menu, Table } from 'semantic-ui-react';
import { DataNotFound } from '../../../../components/DataNotFound';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import SearchFilters from '../../../../components/elements/SearchFilter';
import { postAsync } from '../../../../components/helper/axiosHelper';
import { downloadCSV } from '../../../../components/helper/downloadCSVHelper';
import { uuid4 } from '../../../../libs';
import { PageHitCountApi } from '../../../../shared/Helper';
import { printTable } from '../../../../utils/tableExportUtils';
const SDProjectApprovalList = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [apiData, setApiData] = useState([]);
  const [approveStatus, setApproveStatus] = useState(0);
  const [dateTo, setDateTo] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [isLoad, setIsLoad] = useState(false);
  const [datanotfound, setDatanotfound] = useState(false);
  const [next, setNext] = useState(1);
  const [pageOptions, setPageOptions] = useState({
    pageNo: 1,
    pageSize: 20,
  });

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const token = localStorage.getItem('token');
  const epUser = localStorage.getItem('apid');
  const isLogin = () => {
    if (!token && !epUser) {
      navigate('/managementLogin');
    }
  };

  useEffect(() => {
    const adminID = localStorage.getItem('apid');
    if (adminID) {
      PageHitCountApi(pathname, adminID);
    }
  }, []);

  const bodyGet = {
    EPUserID: 0,
  };

  const DateFilters = {
    epUserID: 0,
    dateFrom: dateFrom ? moment(dateFrom).format('DD/MM/YYYY') : '',
    dateTo: dateTo ? moment(dateTo).format('DD/MM/YYYY') : '',
    statusID: approveStatus,
  };
  const getData = async () => {
    setIsLoad(true);
    setDatanotfound(false);
    await postAsync(
      'ServiceDead/GetSDApprovalFilterList/' + pageOptions.pageNo + '/' + pageOptions.pageSize,
      DateFilters,
    )
      .then((response) => {
        setIsLoad(false);
        setApiData(response?.data);
        setPageCount(response.page);
        setNext(pageOptions.pageNo);
        if (response?.statusCode == 204) {
          setDatanotfound(true);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  useEffect(() => {
    localStorage.setItem('isHome', false);
    isLogin();
    getData();
  }, []);

  const changePage = async ({ selected }) => {
    const select = selected + 1;
    await postAsync('ServiceDead/GetSDApprovalFilterList/' + select + '/' + pageOptions.pageSize, bodyGet)
      .then((response) => {
        setApiData(response?.data);
        setPageCount(response?.page);
        setNext(selected + 1);
      })
      .catch((err) => {
        console.log(err);
        toast.error(`${t('msg_errorDueto')}` + ':' + err.message);
      });
  };

  const displayRecords = apiData?.map((data, index) => {
    const sno = (next - 1) * pageOptions.pageSize + index + 1;

    return (
      <Table.Row items={apiData} key={uuid4()}>
        <Table.Cell>{sno}</Table.Cell>
        <Table.Cell>{data?.applicantName}</Table.Cell>
        <Table.Cell>{data?.date}</Table.Cell>
        <Table.Cell>{isActive ? data?.newProjectName : data?.newProjectName}</Table.Cell>
        <Table.Cell>
          {t(`${data.maApproveID === 1 ? 'Approved' : data.maApproveID === 2 ? 'Disapproved' : 'Pending'}`)}
        </Table.Cell>
        <Table.Cell>
          <Link to={`/SDProjectApproval/${data.serviceDeadID}`}>
            <button className="text-white w-20 bg-customgreen transition duration-700 ease-in-out hover:bg-hovergreen focus:outline-none font-medium rounded-full text-sm px-4 py-2 me-2 text-center">
              <VisibilityOutlinedIcon />
            </button>
          </Link>
        </Table.Cell>
      </Table.Row>
    );
  });

  // Export xlsl file
  // const handleOnExport = () => {
  //   const filteredData = apiData?.map((item, ii) => ({
  //     'S.No': ii + 1,
  //     'Applicant Name': item.applicantName,
  //     'Date of Apply': item.date,
  //     'Project Name': item.newProjectName,
  //     // 'Item Level': item.menuLevelID,
  //     Status: item.maApproveID === 1 ? t('Approved') : item.maApproveID === 2 ? t('Disapproved') : t('Pending'),
  //   }));

  //   downloadCSV(filteredData, 'SD Project Approval List');
  // };
  const handleOnExport = () => {
    const filteredData = apiData?.map((item, ii) => ({
      [t('S.No')]: ii + 1,
      [t('Applicant Name')]: item.applicantName,
      [t('Date of Apply')]: item.date,
      [t('Project Name')]: item.newProjectName,
      [t('Status')]: item.maApproveID === 1 ? t('Approved') : item.maApproveID === 2 ? t('Disapproved') : t('Pending'),
    }));

    downloadCSV(filteredData, t('SD Project Approval List'));
  };

  // const handlePrint = (e) => {
  //   e.preventDefault();
  //   const tableContainer = document.createElement('div');
  //   tableContainer.className = 'tableData my-4';

  //   // Create and add the heading
  //   const heading = document.createElement('h1');
  //   heading.className = 'font-bold text-center my-8 sm:text-2xl text-xl text-customgreen';
  //   heading.innerText = `${t('Service For Dead Approval List')}`;
  //   tableContainer.appendChild(heading);

  //   const table = document.createElement('table');
  //   table.style.width = '100%';
  //   table.innerHTML = `
  //   <thead style="background-color: #2f855a; color: white;">

  //     <tr>
  //       <th style="padding: 5px; border: 1px solid #ddd;">#</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t('Applicant Name')}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Date of Apply`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Project Name`)}</th>
  //       <th style="padding: 5px; border: 1px solid #ddd;">${t(`Status`)}</th>

  //     </tr>
  //   </thead>
  //   <tbody>
  //     ${apiData
  //       .map(
  //         (data, index) => `
  //           <tr style="background-color: ${index % 2 === 0 ? '#f9f9f9' : '#fff'}; border: 1px solid #ddd;">
  //             <td style="padding: 5px; border: 1px solid #ddd;">${index + 1}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.applicantName}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data?.date}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${isActive ? data?.newProjectName : data?.newProjectName}</td>
  //             <td style="padding: 5px; border: 1px solid #ddd;">${data.maApproveID === 1 ? t('Approved') : data.maApproveID === 2 ? t('Disapproved') : t('Pending')}</td>

  //           </tr>
  //         `,
  //       )
  //       .join('')}
  //   </tbody>
  // `;

  //   tableContainer.appendChild(table);
  //   document.body.appendChild(tableContainer);
  //   const style = document.createElement('style');
  //   style.textContent = `
  //   @media print {

  //     body * {
  //       visibility: hidden;
  //       height: 0;

  //     }
  //     .tableData, .tableData * {
  //       visibility: visible;
  //     }
  //     .tableData {
  //       position: absolute;
  //       left: 0;
  //       top: 0;
  //       width: 100%;
  //       height: auto;
  //       overflow: visible;
  //     }
  //   }
  // `;
  //   document.head.appendChild(style);
  //   window.print();
  //   document.body.removeChild(tableContainer);
  //   document.head.removeChild(style);

  //   return 'success';
  // };
const handlePrint = (e) => {
  e.preventDefault();
  
  // Column configuration
  const columns = [
    {
      header: t('sNo'),
      accessor: (row, index) => index + 1
    },
    {
      header: t('Applicant Name'),
      accessor: (row) => isActive ? row?.applicantName : row?.applicantName
    },
     {
      header: t('Date of Apply'),
      accessor: (row) => isActive ? row?.date : row?.date
    },   {
      header: t('Project Name'),
      accessor: (row) => isActive ? row?.newProjectName  || 'N/A' : row?.newProjectName  || 'N/A'
    },{
  header: t('Status'),
  // accessor: (row) =>
  //   isActive
  //     ? row.maApproveID === 1
  //       ? t('Approved')
  //       : row.maApproveID === 2
  //         ? t('Disapproved')
  //         : t('Pending')
  //     : 'N/A'
   accessor: (row) =>
      row.maApproveID === 1
        ? t('Approved')
        : row.maApproveID === 2
          ? t('Disapproved')
          : t('Pending')
}



  ];
  
  // Call the reusable print function
  printTable({
    data: apiData || [],
    isRTL: isActive, // isActive true = Arabic = RTL
    t: t,
    title: `${t('Press Release List')} `,
    columns: columns,
    onBeforePrint: () => {
      console.log('Printing started...');
      // toast.info(t('Preparing print preview...'));
    },
    onAfterPrint: () => {
      console.log('Printing completed');
    },
    styles: {
      customCSS: `
        /* Additional custom styles if needed */
        .print-table th {
          font-weight: 600;
        }
        @media print {
          .print-title {
            color: #000 !important;
          }
        }
      `
    }
  });
};
  return (
    <div className="">
      {!isLogin ? (
        <h1>NOT AUTHORIZED</h1>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row  justify-center py-5 mt-3 ">
              <SearchFilters
                handleSearch={getData}
                setDateFrom={setDateFrom}
                setDateTo={setDateTo}
                dateTo={dateTo}
                dateFrom={dateFrom}
                handlePrint={handlePrint}
                handleOnExport={handleOnExport}
                heading={'Service For Dead Approval List'}
              />
              <div className="col-lg-11 pt-9 ">
                <div className="relative   overflow-x-auto shadow-md sm:rounded-lg">
                  {isLoad ? (
                    <LoadingAnimation />
                  ) : (
                    <Table className="text-sm tableData text-left rtl:text-right">
                      <Table.Header className="font-bold text-white bg-customgreen uppercase">
                        <Table.Row className="whitespace-nowrap">
                          <Table.HeaderCell className="text-white">{t('sNo')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Applicant Name')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Date of Apply')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Project Name')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Status')}</Table.HeaderCell>
                          <Table.HeaderCell className="text-white">{t('Action')}</Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>

                      <Table.Body>{displayRecords}</Table.Body>
                    </Table>
                  )}
                  {datanotfound && <DataNotFound />}
                </div>
                {pageCount > 0 && (
                  <div className="flex flex-row px-12 justify-between ">
                    <Menu floated="right">
                      <Menu.Item>
                        <ReactPaginate
                          previousLabel={t('Previous')}
                          nextLabel={t('Next')}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={'paginationButtons'}
                          previousLinkClassName={'previousButton'}
                          nextLinkClassName={'nextButton'}
                          disabledClassName={'paginationDisabled'}
                          activeClassName={'paginationActive'}
                        />
                      </Menu.Item>
                    </Menu>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SDProjectApprovalList;
